import { Link } from 'react-router-dom'
import { CandidateWarning } from '../components/CandidateWarning'
import { SiteFooter } from '../components/SiteFooter'

export function AboutPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <CandidateWarning />

      <nav className="bg-magar-700 px-4 py-3">
        <div className="max-w-3xl mx-auto flex items-center gap-4">
          <Link to="/" className="text-white/80 hover:text-white text-sm flex items-center gap-1">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Search
          </Link>
          <span className="text-white/40">·</span>
          <span className="text-white font-semibold text-sm">About &amp; Credits</span>
        </div>
      </nav>

      <main className="flex-1 max-w-3xl mx-auto w-full px-4 py-10 space-y-10">

        <section className="space-y-4">
          <h1 className="text-3xl font-bold text-magar-700">About This Dictionary</h1>
          <div className="prose prose-stone max-w-none space-y-3 text-stone-700 leading-relaxed">
            <p>
              This is a <strong>community-review dictionary</strong> for the Magar language —
              a Tibeto-Burman language spoken in Nepal. Entries cover Magar words in both
              Devanagari and Roman script, with Nepali and English equivalents.
            </p>
            <p>
              <strong>Public suggestions</strong> submitted through this site are stored
              separately in a review queue. They do not immediately change dictionary entries.
              All suggestions are reviewed before any edits are accepted.
            </p>
            <p>
              We strongly encourage <strong>native Magar speakers</strong> to review entries
              and submit corrections. Community feedback is the primary path to improving accuracy.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-magar-700">How to Help</h2>
          <div className="space-y-2 text-stone-700">
            <p>If you are a Magar speaker or linguist, you can help by:</p>
            <ul className="list-disc list-inside space-y-1 text-stone-600 ml-2">
              <li>Searching for words you know and checking their translations.</li>
              <li>
                Clicking <strong>"Suggest a Correction"</strong> on any entry that is
                wrong, incomplete, or missing a dialect variant.
              </li>
              <li>Submitting dialect notes — Magar has regional varieties and this matters.</li>
              <li>Flagging entries marked "Needs Review" that need expert attention.</li>
            </ul>
            <p className="mt-2">
              Your submissions are reviewed before any change is made to the dictionary.
              You can leave your name and email if you want to be credited.
            </p>
          </div>
          <Link to="/" className="btn-primary inline-flex mt-2">
            Start searching →
          </Link>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-bold text-magar-700">Search Tips</h2>
          <ul className="list-disc list-inside space-y-2 text-stone-600 ml-2">
            <li>Search in <strong>Magar Devanagari</strong> (ङा) or <strong>Roman</strong> (nga)</li>
            <li>Search in <strong>Nepali Devanagari</strong> (म) or <strong>Roman</strong> (ma)</li>
            <li>Search in <strong>English</strong> (I, me, pronoun…)</li>
          </ul>
        </section>

      </main>

      <SiteFooter />
    </div>
  )
}
